import {
  asyncRouterMap,
  constantRouterMap
} from '@/router/index';
//判断是否有权限访问该菜单
function hasPermission(menus, route) {
  if (route.name) {
    // let currMenu = getMenu(route.meta.permission, menus);
    let currMenu = getMenu(route, menus);
    if (currMenu != null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== '') {
        route.meta.title = currMenu.title;
      }
      // if (currMenu.icon != null && currMenu.title !== '') {
      //   route.meta.icon = currMenu.icon;
      // }
      // if (currMenu.hidden != null) {
      //   route.hidden = currMenu.hidden !== 0;
      // }
      if (currMenu.sort != null && currMenu.sort !== '') {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort = -1;
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true
  }
}

//根据路由名称获取菜单
function getMenu(route, menus) {

  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    // if (menu.children && menu.children.length) {
    //   getChildrenMenu(menu.url, menu.children)
    // }
    if (route.meta.permission === menu.permission) {
      return {
        ...menu, 
        meta: route.meta
      };
    }

  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if (router.children && router.children.length > 0) {
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p) {
  return function (m, n) {
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}
//TODO
function filterBtns(menus, auth) {
  menus.forEach(item => {
    if (item.children && item.children.length) {
      item.children.forEach(val => {
        if (val.type == 'button') {
          auth.btns.push(val.permission)
        }
        if (val.children && val.children.length) {
          filterBtns(val.children, auth)
        }
      })
    }
  })

}

const permission = {
  state: {
    routers: constantRouterMap,
    btns: [],
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
      // console.log(state.routers)
    }
  },
  actions: {
    GenerateRoutes({
      commit,
      state
    }, data) {
      // console.log(data, asyncRouterMap, '81')
      return new Promise(resolve => {
        const {
          menus
        } = data;

        // const { username } = data;
        filterBtns(menus, state);
        const accessedRouters = asyncRouterMap.filter(v => {
          //admin帐号直接返回所有菜单
          // if(username==='admin') return true;
          //menu 所有菜单， v
          //TODO 目前只有后端接口返回一层路由 适用
          if (hasPermission(menus, v)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                // console.log(child,'child')
                if (hasPermission(menus, child)) {
                  return child
                }
                return false;
              });
              return v
            } else {
              return v
            }
          }
          return false;
        });
        //对菜单进行排序
        // sortRouters(accessedRouters);
        // console.log(accessedRouters)
        commit('SET_ROUTERS', accessedRouters);


        resolve();
      })
    }
  }
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js